import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRouter from "./homeRouter";
import adminRouter from "./adminRouter";
import massesRouter from "./massesRouter";
import massesH5Router from "@/router/massesH5Router";
import {_isMobile} from "@/utils/utils";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/masses'
    },
    {
        path: '/login',
        component: () => import('../views/login/login'),
        meta: {
            title: '登录',
            needLogin: false
        }
    },
    {
        path: '/home',
        component: () =>
            import ('../views/home/home'),
        children: homeRouter,
    },
    {
        path: '/admin',
        component: () =>
            import ('../views/admin/home'),
        children: adminRouter,
    },
    {
        path: '/masses',
        component: () =>
            import ('../views/masses/home'),
        children: massesRouter,
    },
    {
        path: '/h5/masses',
        component: () =>
            import ('../views/h5/home'),
        children: massesH5Router,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
})


router.beforeEach((to, from, next) => {
    // 公众端 兼容 h5端 其他端不做处理，现在简易判断 ，后期可以加入路由验证
    if (to.path.includes('/masses/masses/')) {
        let paths = to.path.split('/')
        if (_isMobile()) {
            let index = paths.indexOf('h5')
            if (index === -1) {
                paths[0] = '/h5'
            }
        } else {
            let index = paths.indexOf('h5')
            if (index !== -1) {
                paths.splice(index, 1)
            }
        }
        let rePath = paths.join('/')
        if (rePath === to.path) {
            next()
        } else {
            next({
                path: rePath,
                params: to.params,
                query: to.query
            })
        }
    } else {
        next()
    }
});


export default router
